
(() => {
  const STICKY_SELECTOR = '[data-sticky-atc]';
  const ADD_BTN_SELECTOR = '[data-sticky-atc-add]';
  const PRICE_SELECTOR = '[data-sticky-atc-price]';
  const SKU_SELECTOR = '[data-sticky-atc-sku]';
  const SIZE_SELECTOR = '[data-sticky-atc-size]';
  const COLOR_SELECTOR = '[data-sticky-atc-color]';
  const VARIANT_SEP_SELECTOR = '[data-sticky-atc-variant-sep]';
  const BUY_NOW_BTN_SELECTOR = '[data-sticky-atc-buy-now]';
  const TRIGGER_SELECTOR = '[data-sticky-atc-trigger]';

  const FALLBACK_SHOW_OFFSET_PX = 700;

  const getViewportWidth = () => window.innerWidth || document.documentElement.clientWidth;
  const isMobileViewport = () => getViewportWidth() <= 989;

  const getPrimaryProductInfo = () => document.querySelector("product-info[id^='MainProduct']") || document.querySelector('product-info');

  const getVariantSelects = () => {
    const productInfo = getPrimaryProductInfo();
    return productInfo?.querySelector('variant-selects') || document.querySelector('variant-selects');
  };

  const getSelectedVariantFromDom = () => {
    const variantSelects = getVariantSelects();
    const scriptEl = variantSelects?.querySelector('script[type="application/json"][data-selected-variant]');
    if (!scriptEl) return null;
    try {
      return JSON.parse(scriptEl.textContent);
    } catch (e) {
      return null;
    }
  };

  const getPrimaryAddToCartForm = () => {
    const productInfo = getPrimaryProductInfo();
    return (
      productInfo?.querySelector('form[data-type="add-to-cart-form"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]')
    );
  };

  const getPrimarySubmitButton = () => {
    const form = getPrimaryAddToCartForm();
    return form?.querySelector('button[type="submit"], [type="submit"]') || null;
  };

  const setStickyState = (stickyEl, shouldShow) => {
    stickyEl.classList.toggle('hidden', !shouldShow);
    document.body.classList.toggle('has-sticky-atc', shouldShow && isMobileViewport());
  };

  const extractPriceText = (rootEl) => {
    if (!rootEl) return '';
    const salePrice = rootEl.querySelector('.price-item--sale.price-item--last') || rootEl.querySelector('.price-item--sale');
    const regularPrice = rootEl.querySelector('.price__regular .price-item--regular') || rootEl.querySelector('.price-item--regular');
    const chosen = salePrice || regularPrice;
    return (chosen?.textContent || '').replace(/\s+/g, ' ').trim();
  };

  const getCurrentPriceTextFromDom = (stickyEl) => {
    const sectionId = stickyEl.dataset.sectionId;
    const sourcePrice = sectionId ? document.getElementById(`price-${sectionId}`) : null;
    return extractPriceText(sourcePrice);
  };

  const syncImageFromVariant = (stickyEl, variant) => {
    const img = stickyEl.querySelector('.sticky-atc-bar__image');
    if (!img || !variant) return;

    const variantImageSrc =
      variant.featured_image?.src ||
      variant.featured_image ||
      variant.featured_media?.preview_image?.src ||
      '';

    if (!variantImageSrc) return;

    img.src = variantImageSrc;
  };

  const syncSku = (stickyEl, variant) => {
    const skuEl = stickyEl.querySelector(SKU_SELECTOR);
    if (!skuEl) return;
    const sku = (variant?.sku || '').toString();
    skuEl.textContent = sku;
    skuEl.closest('.sticky-atc-bar__sku')?.classList.toggle('hidden', !sku);
  };

  const getDynamicCheckoutButton = () => {
    const form = getPrimaryAddToCartForm();
    if (!form) return null;
    return (
      form.querySelector('.shopify-payment-button__button') ||
      form.querySelector('.shopify-payment-button button')
    );
  };

  const normalizeOptionName = (value) => (value || '').toString().trim().toLowerCase();

  const findOptionContainer = (matchers) => {
    const productInfo = getPrimaryProductInfo();
    if (!productInfo) return null;

    const containers = productInfo.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input--dropdown');
    const container = Array.from(containers).find((el) => {
      const labelEl = el.querySelector('legend .form__label-text') || el.querySelector('label .form__label-text') || el.querySelector('legend') || el.querySelector('label');
      const labelText = normalizeOptionName(labelEl?.textContent || '');
      return matchers.some((m) => labelText.includes(m));
    });
    if (!container) return null;

    const radio = container.querySelector('input[type="radio"][name], input[type="checkbox"][name]');
    const select = container.querySelector('select[id^="Option-"]');

    let position = 0;
    if (radio) {
      const name = radio.getAttribute('name') || '';
      const match = name.match(/-(\d+)\s*$/);
      if (match) position = Number(match[1]) || 0;
    } else if (select) {
      const id = select.getAttribute('id') || '';
      const match = id.match(/-(\d+)\s*$/);
      if (match) position = (Number(match[1]) || 0) + 1;
    }

    return { container, position };
  };

  const getSelectedValueFromContainer = (optionContainer) => {
    if (!optionContainer) return '';
    const { container } = optionContainer;
    const select = container.querySelector('select');
    if (select) return (select.value || '').trim();

    const checked = container.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
    if (checked) return (checked.value || '').trim();

    return '';
  };

  const getVariantOptionValueByPosition = (variant, position) => {
    if (!variant || !position) return '';
    const key = `option${position}`;
    if (variant[key]) return variant[key].toString().trim();
    if (Array.isArray(variant.options) && variant.options[position - 1]) return variant.options[position - 1].toString().trim();
    return '';
  };

  const syncSize = (stickyEl, variant) => {
    const sizeValueEl = stickyEl.querySelector(SIZE_SELECTOR);
    if (!sizeValueEl) return;

    const wrapper = sizeValueEl.closest('.sticky-atc-bar__variant-item--size');

    const optionContainer = findOptionContainer(['size', 'ukuran']);
    let sizeValue = getSelectedValueFromContainer(optionContainer);
    if (!sizeValue && variant) sizeValue = getVariantOptionValueByPosition(variant, optionContainer?.position);

    sizeValueEl.textContent = sizeValue;
    wrapper?.classList.toggle('hidden', !sizeValue);
  };

  const syncColor = (stickyEl, variant) => {
    const colorValueEl = stickyEl.querySelector(COLOR_SELECTOR);
    if (!colorValueEl) return;

    const wrapper = colorValueEl.closest('.sticky-atc-bar__variant-item--color');

    const optionContainer = findOptionContainer(['color', 'colour', 'warna']);
    let colorValue = getSelectedValueFromContainer(optionContainer);
    if (!colorValue && variant) colorValue = getVariantOptionValueByPosition(variant, optionContainer?.position);

    colorValueEl.textContent = colorValue;
    wrapper?.classList.toggle('hidden', !colorValue);
  };

  const syncVariantMetaLine = (stickyEl) => {
    const sizeValue = (stickyEl.querySelector(SIZE_SELECTOR)?.textContent || '').trim();
    const colorValue = (stickyEl.querySelector(COLOR_SELECTOR)?.textContent || '').trim();

    const line = stickyEl.querySelector('.sticky-atc-bar__variant');
    const sep = stickyEl.querySelector(VARIANT_SEP_SELECTOR);

    if (sep) sep.toggleAttribute('hidden', !(sizeValue && colorValue));
    if (line) line.classList.toggle('hidden', !(sizeValue || colorValue));
  };

  const syncFromMainButton = (stickyEl) => {
    const stickyAddBtn = stickyEl.querySelector(ADD_BTN_SELECTOR);
    const mainBtn = getPrimarySubmitButton();
    if (!stickyAddBtn || !mainBtn) return;

    const baseClasses = Array.from(stickyAddBtn.classList);
    stickyAddBtn.className = `${baseClasses.join(' ')} ${mainBtn.className}`.trim();

    const isDisabled = mainBtn.hasAttribute('disabled') || mainBtn.getAttribute('aria-disabled') === 'true';
    stickyAddBtn.toggleAttribute('disabled', isDisabled);

    stickyAddBtn.innerHTML = mainBtn.innerHTML;
  };

  const syncBuyNowButton = (stickyEl) => {
    const buyNowBtn = stickyEl.querySelector(BUY_NOW_BTN_SELECTOR);
    if (!buyNowBtn) return;

    const dynamicBtn = getDynamicCheckoutButton();
    const shouldShow = !!dynamicBtn && !dynamicBtn.hasAttribute('disabled') && dynamicBtn.getAttribute('aria-disabled') !== 'true';
    buyNowBtn.toggleAttribute('hidden', !shouldShow);

    if (!dynamicBtn || !shouldShow) return;

    const baseClasses = Array.from(buyNowBtn.classList);
    buyNowBtn.className = `${baseClasses.join(' ')} ${dynamicBtn.className}`.trim();
    buyNowBtn.innerHTML = dynamicBtn.innerHTML;
  };

  const syncFromVariantChangeEvent = (stickyEl, variant, html) => {
    if (!variant) return;

    const priceEl = stickyEl.querySelector(PRICE_SELECTOR);

    syncSku(stickyEl, variant);
    syncImageFromVariant(stickyEl, variant);

    syncSize(stickyEl, variant);
    syncColor(stickyEl, variant);
    syncVariantMetaLine(stickyEl);

    if (priceEl && html) {
      const sectionId = stickyEl.dataset.sectionId;
      const sourcePrice = html.getElementById(`price-${sectionId}`);
      if (sourcePrice) {
        const priceText = extractPriceText(sourcePrice);
        if (priceText) priceEl.textContent = priceText;
      }
    }

    const stickyAddBtn = stickyEl.querySelector(ADD_BTN_SELECTOR);
    if (stickyAddBtn) stickyAddBtn.toggleAttribute('disabled', !variant.available);
  };

  const throttle = (fn, wait) => {
    let last = 0;
    let timeoutId;
    return (...args) => {
      const now = Date.now();
      const remaining = wait - (now - last);
      if (remaining <= 0) {
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = undefined;
        last = now;
        fn(...args);
      } else if (!timeoutId) {
        timeoutId = setTimeout(() => {
          last = Date.now();
          timeoutId = undefined;
          fn(...args);
        }, remaining);
      }
    };
  };

  const shouldShowFallback = () => {
    const scrollBottom = window.scrollY + window.innerHeight;
    const docHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight,
      document.documentElement.offsetHeight,
      document.body.offsetHeight
    );
    return docHeight - scrollBottom <= FALLBACK_SHOW_OFFSET_PX;
  };

  const isNearTrigger = (trigger, offsetPx = 250) => {
    if (!trigger) return false;
    const rect = trigger.getBoundingClientRect();
    return rect.top <= window.innerHeight + offsetPx;
  };

  const isTriggerInView = (trigger) => {
    if (!trigger) return false;
    const rect = trigger.getBoundingClientRect();
    return rect.top <= window.innerHeight && rect.bottom >= 0;
  };

  const mountSticky = (stickyEl) => {
    if (stickyEl.dataset.stickyAtcMounted === 'true') return;
    stickyEl.dataset.stickyAtcMounted = 'true';

    const stickyAddBtn = stickyEl.querySelector(ADD_BTN_SELECTOR);
    if (!stickyAddBtn) return;

    const buyNowBtn = stickyEl.querySelector(BUY_NOW_BTN_SELECTOR);

    const onClick = () => {
      const form = getPrimaryAddToCartForm();
      const mainBtn = getPrimarySubmitButton();
      if (!form || !mainBtn) return;
      if (mainBtn.hasAttribute('disabled') || mainBtn.getAttribute('aria-disabled') === 'true') return;

      mainBtn.focus({ preventScroll: true });
      if (typeof mainBtn.click === 'function') {
        mainBtn.click();
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    };

    stickyAddBtn.addEventListener('click', onClick);

    const mainBtnObserver = (() => {
      const mainBtn = getPrimarySubmitButton();
      if (!mainBtn || typeof MutationObserver === 'undefined') return null;

      const observer = new MutationObserver(() => {
        syncFromMainButton(stickyEl);
      });

      observer.observe(mainBtn, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class']
      });

      return observer;
    })();

    const dynamicBtnObserver = (() => {
      if (typeof MutationObserver === 'undefined') return null;
      const form = getPrimaryAddToCartForm();
      if (!form) return null;

      const observer = new MutationObserver(() => {
        syncBuyNowButton(stickyEl);
      });

      observer.observe(form, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true
      });

      return observer;
    })();

    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', () => {
        const dynamicBtn = getDynamicCheckoutButton();
        if (!dynamicBtn) return;
        if (dynamicBtn.hasAttribute('disabled') || dynamicBtn.getAttribute('aria-disabled') === 'true') return;
        dynamicBtn.click();
      });
    }

    // Variant change sync
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        syncFromVariantChangeEvent(stickyEl, data?.variant, data?.html);
        syncFromMainButton(stickyEl);
        syncBuyNowButton(stickyEl);
        syncSize(stickyEl, data?.variant);
        syncColor(stickyEl, data?.variant);
        syncVariantMetaLine(stickyEl);
      });
    }

    // Keep sticky button label/disabled in sync (e.g. when inventory rules toggle)
    document.addEventListener('click', () => syncFromMainButton(stickyEl), { passive: true });
    document.addEventListener(
      'change',
      () => {
        syncFromMainButton(stickyEl);
        const variant = getSelectedVariantFromDom();
        syncSku(stickyEl, variant);
        syncSize(stickyEl, variant);
        syncColor(stickyEl, variant);
        syncVariantMetaLine(stickyEl);
        syncImageFromVariant(stickyEl, variant);
        const priceEl = stickyEl.querySelector(PRICE_SELECTOR);
        const priceText = getCurrentPriceTextFromDom(stickyEl);
        if (priceEl && priceText) priceEl.textContent = priceText;
        syncBuyNowButton(stickyEl);
      },
      { passive: true }
    );

    // Figma behavior: hidden initially; show only after reaching the bottom trigger
    setStickyState(stickyEl, false);

    const updateVisibility = throttle(() => {
      const trigger = getPrimaryProductInfo()?.querySelector(TRIGGER_SELECTOR) || document.querySelector(TRIGGER_SELECTOR);
      const show = trigger ? isTriggerInView(trigger) : false;
      setStickyState(stickyEl, show);
    }, 150);

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });

    updateVisibility();

    syncFromMainButton(stickyEl);
    syncBuyNowButton(stickyEl);

    const initialVariant = getSelectedVariantFromDom();
    syncSku(stickyEl, initialVariant);
    syncSize(stickyEl, initialVariant);
    syncColor(stickyEl, initialVariant);
    syncVariantMetaLine(stickyEl);
    syncImageFromVariant(stickyEl, initialVariant);

    const priceEl = stickyEl.querySelector(PRICE_SELECTOR);
    const priceText = getCurrentPriceTextFromDom(stickyEl);
    if (priceEl && priceText) priceEl.textContent = priceText;
  };

  const init = () => {
    document.querySelectorAll(STICKY_SELECTOR).forEach((stickyEl) => mountSticky(stickyEl));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('product-info:loaded', () => {
    init();
  });
})();
